<template>
    <div>
        <layout>
            <Search slot="header-bar" placeholder="请输入关键字搜索" v-model="searchInput" @search="onRefresh"/>
            <PullRefresh v-model="isReFresh" @refresh="onRefresh">
                <List
                        style="padding: 5px 12px"
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        loading-text="拼命加载中..."
                        @load="onLoad"
                        :offset="50"
                        :immediate-check="true"
                >
                    <InspectDeviceItem v-for="item in inspectDeviceList" :key="item.id" :inspectDevice="item"/>
                </List>
            </PullRefresh>
        </layout>
    </div>
</template>

<script>
    import {List, PullRefresh, Search} from "vant"
    import InspectItem from "../components/InspectItem";
    import InspectDeviceItem from "../components/InspectDeviceItem";


    export default {
        components: {InspectDeviceItem, InspectItem, Search, PullRefresh, List},
        props: {},
        data() {
            return {
                inspectTaskId: this.$route.params.id,
                searchInput: null,
                isReFresh: false,
                loading: false,
                finished: false,
                inspectDeviceList: []
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            onRefresh() {
                this.isReFresh = true;
                this.inspectDeviceList = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                this.$http.tokiot.inspectTask.inspectDevice({
                    inspectTaskId: this.inspectTaskId,
                    fullText: this.searchInput,
                    size: 20,
                    // page: this.inspectDeviceList.length / 20 + 1
                }).then(res => {
                    if (res) {
                        this.inspectDeviceList.push(...res.rows);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.inspectDeviceList.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
        },
        watch: {}
    }
</script>

<style scoped>


</style>